
import './App.css';
import Home from './Components/Home/Home';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { Route, Routes ,useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import AdminPage from './Components/AdminPage/AdminPage';
import HomeNew from './Components/Home/HomeNew';
import MakePaymentButton from './Components/MakePayment/MakePaymentButton';
import ThankYouPage from './Components/ThankYou/ThankYouPage';
import AdminDashboard from './Components/AdminPage/AdminDashboard';
function App() {
  const location = useLocation();
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
      easing: 'ease-out',
    });
  }, []);
  const hidebutton = ['/thankyou'].some(path => location.pathname.startsWith(path));
  return (
    <div className="App">
    
      <Routes>
    <Route exact path="/" element={<Home />} />
    <Route exact path="/home" element={<HomeNew />} />

      
      <Route exact path="/admingfvfsdr" element={<AdminPage/>} />
      <Route exact path="/thankyou" element={<ThankYouPage/>} />
      <Route exact path="/admin" element={<AdminDashboard/>} />

      




</Routes>
{!hidebutton && <MakePaymentButton/>}

    </div>
  );
}

export default App;
